import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-dash',
  templateUrl: './loading-dash.component.html',
  styleUrls: ['./loading-dash.component.scss']
})
export class LoadingDashComponent
{
  @Input() size: 'card-top' | 'card-middle' | 'graph-middle' | 'default' = 'default';

  public getCssClass(): string {
    switch (this.size) {
      case 'card-top': return 'm-11';
      case 'card-middle': return 'm-17';
      case 'graph-middle': return 'm-95';
      default: return '';
    }
  }
}
